// export const baseUrl = 'https://localhost:7177';
export const baseUrl = 'https://www.zimtareports.web.za';
export const loansUrl = 'https://www.zimtaloans.web.za';

export const layoutConstant = {
  topbarHeight: 40,
  grocerySidenavWidth: 280,
  containerWidth: 1200,
  mobileNavHeight: 64,
  headerHeight: 80,
  mobileHeaderHeight: 64
};

export const environmentCurr = 'LIVE ENVIRONMENT'; // LIVE ENVIRONMENT
// export const environmentCurr = 'TEST ENVIRONMENT';

export const paymentMethod = [
  { refId: 'Cash', name: 'Cash' },
  { refId: 'Ecocash', name: 'Ecocash' },
  { refId: 'Swipe', name: 'Swipe' }
];

export const agents = [
  { refId: 14, description: 'Jingo' },
  { refId: 16, description: 'Takurai' },
  { refId: 22, description: 'Edmore' }
];

export const gender = [
  { refId: 0, name: 'None' },
  { refId: 1, name: 'Male' },
  { refId: 2, name: 'Female' },
  { refId: 3, name: 'Unknown' },
  { refId: 4, name: 'Both' }
];

export const titles = [
  { refId: 0, name: 'None.' },
  { refId: 1, name: 'Mr.' },
  { refId: 2, name: 'Mrs.' },
  { refId: 3, name: 'Ms.' },
  { refId: 4, name: 'Dr.' }
];

export const productsa = [
  { label: 'The Shawshank Redemption', year: 1994 },
  { label: 'The Godfather', year: 1972 },
  { label: 'The Godfather: Part II', year: 1974 },
  { label: 'The Dark Knight', year: 2008 },
  { label: '12 Angry Men', year: 1957 },
  { label: "Schindler's List", year: 1993 },
  { label: 'Pulp Fiction', year: 1994 }
];

export const userDept = [
  { refId: 1, name: 'SDA Dept.' },
  { refId: 2, name: 'Tuition Dept.' },
  { refId: 3, name: 'Bursar.' },
  { refId: 4, name: 'Headmaster.' },
  { refId: 5, name: 'Admin.' }
];

export const userStatuses = [
  { refId: 1, name: 'Active.' },
  { refId: 0, name: 'InActive' }
];

export const Country = [
  { refId: 1, name: 'Zimbabwe' },
  { refId: 2, name: 'South Africa' }
];

export const loanReasons = [
  { refId: 1, name: 'Furniture' },
  { refId: 2, name: 'Consumption' },
  { refId: 3, name: 'Debt Consolidation' },
  { refId: 4, name: 'Education' },
  { refId: 5, name: 'Emergency' },
  { refId: 6, name: 'Funeral Expenses' },
  { refId: 7, name: 'Housing/Home Improvement' },
  { refId: 8, name: 'Interruption/Loss of Income' },
  { refId: 9, name: 'Household Expenses' },
  { refId: 10, name: 'Medical Expenses' }
];

export const verificationState = [
  { refId: 0, name: 'Pending' },
  { refId: 1, name: 'Verified' }
];

export const tariffTypes = [
  { refId: 'SofB', name: 'SofB' },
  { refId: 'Priv', name: 'Priv' }
];

export const employerTypes = [
  { refId: 0, name: 'Private Payroll' },
  { refId: 1, name: 'Government Payroll' },
  { refId: 2, name: 'Non Payroll' },
  { refId: 3, name: 'SMME' },
  { refId: 4, name: 'Group' },
  { refId: 5, name: 'Unknown Employer Type' }
];

export const paymentFrequencies = [
  { refId: 1, name: 'Monthly' },
  { refId: 2, name: 'Weekly' }
];

export const monthlySalaryReceiveDateTypes = [
  { refId: 0, name: 'Month First Day' },
  { refId: 1, name: 'Month Last Working Day' },
  { refId: 2, name: 'Month Last Day' },
  { refId: 3, name: 'Month Specific Last Day' },
  { refId: 4, name: 'Month Specific Date' }
];

export const paypoints = [
  { refId: 1, name: 'Debit Order' },
  { refId: 2, name: 'Private' },
  { refId: 3, name: 'Government' }
];

export const claimType = [
  { refId: 1, name: 'Retirement Benefit' },
  { refId: 2, name: 'Member Death Benefit' },
  { refId: 3, name: 'Child Death Benefit' },
  { refId: 4, name: 'Spouse Death Benefit' }
];

export const claimTypes = [
  { refId: 0, name: 'All' },
  { refId: 1, name: 'Retirement Benefit' },
  { refId: 2, name: 'Death Benefit' },
  { refId: 3, name: 'Child' },
  { refId: 4, name: 'Spouse' }
];

export const retirementType = [
  { refId: 1, name: 'Normal' },
  { refId: 2, name: 'Early' },
  { refId: 3, name: 'Medical' }
];

export const deductionType = [
  { refId: 'n', name: 'New' },
  { refId: 'c', name: 'Change' },
  { refId: 'd', name: 'Delete' }
];

export const accountType = [
  { refId: 0, name: 'None' },
  { refId: 1, name: 'Cheque' },
  { refId: 2, name: 'Savings' },
  { refId: 3, name: 'Transmission' },
  { refId: 4, name: 'Credit Card' }
];

export const payoutMethods = [
  { refId: 1, name: 'Cheque' },
  { refId: 2, name: 'Cash' },
  { refId: 3, name: 'Bank' },
  { refId: 4, name: 'EDI' }
];

export const revenues = [
  { refId: 7, name: 'Subscriptions' },
  { refId: 8, name: 'Cards Income' },
  { refId: 10, name: 'Provident Fund' }
];

export const tempBanks = [
  { refId: 1, name: 'CBZ' },
  { refId: 2, name: 'Barclays' },
  { refId: 3, name: 'Standard Chartered' },
  { refId: 4, name: 'Time Bank' }
];

export const statuses = [
  { refId: 0, name: 'InActive' },
  { refId: 1, name: 'Active' },
  { refId: 2, name: 'Balanced' }
];

export const batchStatuses = [
  { refId: 1, name: 'Open' },
  { refId: 2, name: 'Balanced' },
  { refId: 3, name: 'Posted' },
  { refId: 4, name: 'Partially Posted' },
  { refId: 5, name: 'Deleted' }
];

export const claimStatuses = [
  { refId: 0, name: 'All' },
  { refId: 1, name: 'Administrator Approval' },
  { refId: 2, name: 'Batch Claim' },
  { refId: 3, name: 'Accountant Approval' },
  { refId: 4, name: 'Principal Officer' },
  { refId: 5, name: 'Awaiting Payment' },
  { refId: 6, name: 'Paid Claims' },
  { refId: 7, name: 'Fees pending' },
  { refId: 8, name: 'Investigations' },
  { refId: 9, name: 'Invalid' },
  { refId: 10, name: 'Imported' },
  { refId: 11, name: 'Rollover' },
  { refId: 13, name: 'Abandoned' },
  { refId: 14, name: 'Insurance Claims' },
  { refId: 17, name: 'Rejected' },
  { refId: 18, name: 'Deferred' }
];

export const authorizationStatus = [
  { refId: 1, name: 'Authorisation pending ' },
  { refId: 2, name: 'Authorised and claims received but not yet paid ' },
  { refId: 3, name: 'Authorisation with claims received and paid' },
  { refId: 4, name: 'Declined' },
  { refId: 5, name: 'Authorisation closed' },
  { refId: 6, name: 'Authorisation approved claim pending' },
  { refId: 7, name: 'Approved' }
];

export const tempProvinces = [
  { refId: 1, name: 'Bulawayo' },
  { refId: 2, name: 'Masvingo' },
  { refId: 3, name: 'Matabeleland North' },
  { refId: 4, name: 'Matabeleland South' },
  { refId: 5, name: 'Harare' },
  { refId: 6, name: 'Midlands' },
  { refId: 7, name: 'Mashonaland West' },
  { refId: 8, name: 'Mashonaland Central' },
  { refId: 9, name: 'Mashonaland East' },
  { refId: 10, name: 'Manicaland' }
];

// export const tempProvinces = [
//   { refId: 0, name: 'Matebeleland' },
//   { refId: 1, name: 'Midlands' },
//   { refId: 2, name: 'Bulawayo' },
//   { refId: 3, name: 'Harare' },
//   { refId: 4, name: 'Masvingo' },
//   { refId: 5, name: 'Mashonaland East' },
//   { refId: 6, name: 'Mashonaland West' },
//   { refId: 7, name: 'Manicaland' }
// ];

export const tempBankBranches = [
  { refId: 0, name: '23001' },
  { refId: 1, name: '8900' },
  { refId: 2, name: '023345' },
  { refId: 3, name: '123312' }
];

export const employers = [
  { refId: 1, name: 'Bulawayo Metropolitan' },
  { refId: 2, name: 'Masvingo Province' },
  { refId: 3, name: 'Mat North Province' },
  { refId: 4, name: 'Mat South Province' },
  { refId: 5, name: 'Harare Metropolitan' },
  { refId: 6, name: 'Midlands Province' },
  { refId: 7, name: 'Mash West Province' },
  { refId: 8, name: 'Mash Central Province' },
  { refId: 9, name: 'Mash East Province' },
  { refId: 10, name: 'Manicaland Province' },
  { refId: 11, name: 'Head office' }
];

// export const employers = [
//   { refId: 1, name: 'Hwange Colliery' },
//   { refId: 2, name: 'Hwange Colliery Pension Fund' }
// ];

export const employerCodes = [
  { refId: 1, name: '80001' },
  { refId: 2, name: '80008' },
  { refId: 3, name: '80002' },
  { refId: 4, name: '80005' },
  { refId: 5, name: '80003' },
  { refId: 6, name: '80007' },
  { refId: 7, name: '80004' },
  { refId: 8, name: '80006' },
  { refId: 9, name: '80009' },
  { refId: 10, name: '80010' },
  { refId: 11, name: '80011' },
  { refId: 12, name: '80012' },
  { refId: 13, name: '80013' },
  { refId: 16, name: '80014' },
  { refId: 17, name: '80015' },
  { refId: 18, name: '80016' },
  { refId: 19, name: '80017' },
  { refId: 21, name: '80018' }
];

export const maritalState = [
  { refId: 1, name: 'Single' },
  { refId: 2, name: 'Married' },
  { refId: 3, name: 'Divorced' },
  { refId: 4, name: 'Widowed' },
  { refId: 5, name: 'Living Together' },
  { refId: 6, name: 'Separated' },
  { refId: 7, name: 'Other' }
];

export const documentType = [
  { refId: 1, description: 'ID' },
  { refId: 2, description: 'Bank Statement' },
  { refId: 3, description: 'Agreement' }
];

export const countries = [
  { refId: 43, name: 'Botswana' },
  { refId: 50, name: 'Malawi' },
  { refId: 42, name: 'South Africa' },
  { refId: 40, name: 'Zambia' },
  { refId: 41, name: 'Zimbabwe' }
];

export const fileTypes = [
  { refId: 1, name: 'Text' },
  { refId: 2, name: 'CSV' }
];

export const processStates = [
  { refId: 0, name: 'Created' },
  { refId: 1, name: 'Matched IDs' },
  { refId: 2, name: 'Complete' }
];

export const ssbStates = [
  { refId: 0, name: 'New' },
  { refId: 1, name: 'Submitted' },
  { refId: 2, name: 'Approved' },
  { refId: 3, name: 'Declined' },
  { refId: 4, name: 'PendingApproved' },
  { refId: 5, name: 'PendingDeclined' }
];

export const tierSchemes = [
  { refId: 1, name: 'Single' },
  { refId: 2, name: '5 Beneficiaries' },
  { refId: 3, name: '6 Beneficiaries' },
  { refId: 4, name: '7 Beneficiaries' },
  { refId: 5, name: '8 Beneficiaries' },
  { refId: 6, name: 'Additional Members' }
];

export const occupations = [
  { refId: 1, name: 'CLERICAL' },
  { refId: 2, name: 'ARTISAN' },
  { refId: 3, name: 'TECHNICAL' },
  { refId: 4, name: 'EXECUTIVE' },
  { refId: 5, name: 'ENGINEER' },
  { refId: 6, name: 'MANUAL' },
  { refId: 7, name: 'ACCOUNTANT' },
  { refId: 8, name: 'SUPERVISORY' },
  { refId: 9, name: 'MANAGERIAL' },
  { refId: 10, name: 'DOMESTIC' },
  { refId: 11, name: 'SERVICE' },
  { refId: 12, name: 'SALES' },
  { refId: 13, name: 'MARKETING' },
  { refId: 14, name: 'STUDENT' },
  { refId: 15, name: 'N/A' }
];

export const memberTypes = [
  { refId: 1, name: 'Spouse' },
  { refId: 2, name: 'Child' },
  { refId: 3, name: 'Nominated' },
  { refId: 4, name: 'Other' }
];

export const languages = [
  { refId: 0, name: 'Unknown' },
  { refId: 1, name: 'English' },
  { refId: 2, name: 'Shona' },
  { refId: 3, name: 'Ndebele' }
];

export const ageRange = [
  { refId: 18, name: '18' },
  { refId: 35, name: '35' },
  { refId: 45, name: '45' },
  { refId: 65, name: '65' }
];

export const relationShips = [
  { refId: 0, name: 'SELF' },
  { refId: 1, name: 'WIFE' },
  { refId: 2, name: 'HUSBAND' },
  { refId: 3, name: 'DAUGHTER' },
  { refId: 4, name: 'SON' },
  { refId: 5, name: 'BROTHER' },
  { refId: 6, name: 'MOTHER' },
  { refId: 7, name: 'FATHER' },
  { refId: 8, name: 'SISTER' },
  { refId: 9, name: 'OTHER' },
  { refId: 10, name: 'SPOUSE' },
  { refId: 11, name: 'CHILD' }
];

export const memberStatuses = [
  { refId: 1, name: 'Active' },
  { refId: 2, name: 'Fees Pending' },
  { refId: 3, name: 'High Risk' },
  { refId: 4, name: 'Frozen' },
  { refId: 5, name: 'Terminated' },
  { refId: 6, name: 'Not Renewed' },
  { refId: 7, name: 'Membership To Rollover' },
  { refId: 8, name: 'Membership Pending' },
  { refId: 9, name: 'Nominated Beneficiary' }
];

export const terminationReasons = [
  { refId: 1, name: 'Over 18' },
  { refId: 2, name: 'Normal Pension' },
  { refId: 3, name: 'Medical Pension' },
  { refId: 4, name: 'Deceased' },
  { refId: 5, name: 'Resigned' },
  { refId: 6, name: 'Dismissed' },
  { refId: 7, name: 'Disserted Rollover' },
  { refId: 8, name: 'Early Retirement' }
];

export const controlAccounts = [
  { refId: '91111', name: 'DEBTORS CONTROL' },
  { refId: '90001', name: 'CBZ BANK' },
  { refId: '90002', name: 'STANBIC BANK' },
  { refId: '99994', name: 'CONTROL CARD - DUPLICATE PAYMENTS.' },
  { refId: '99995', name: 'CONTROL CARD - PRE-PAID CLAIMS.' },
  { refId: '99996', name: 'CONTROL CARD - BANK EXCHANGE.' },
  { refId: '99997', name: 'CONTROL CARD - DISCOUNT.' },
  { refId: '99998', name: 'CONTROL CARD - WORKMANS COMPENSATION.' },
  { refId: '99999', name: 'CONTROL CARD FUND DISPENSARIES' },
  { refId: 'D95555', name: 'CONTROL CARD - PERSONAL ACCOUNT' },
  { refId: 'D99994', name: 'CONTROL CARD - DUPLICATE PAYMENTS.' },
  { refId: 'D99995', name: 'CONTROL CARD - PRE-PAID CLAIMS.' },
  { refId: 'D99996', name: 'CONTROL CARD - BANK EXCHANGE.' },
  { refId: 'D99997', name: 'CONTROL CARD - DISCOUNT.' },
  { refId: 'D99998', name: 'CONTROL CARD - WORKMANS COMPENSATION.' },
  { refId: 'D99999', name: 'CONTROL CARD FUND DISPENSARIES' }
];

export const currencies = [
  { refId: 1, name: 'ZWD' },
  { refId: 2, name: 'Other' },
  { refId: 3, name: 'USD' },
  { refId: 4, name: 'ZiG' }
];

export const revenuesAccounts = [
  { refId: 7, name: 'Subscriptions' },
  { refId: 8, name: 'Cards' },
  { refId: 9, name: 'Other' }
];

export const sectors = [
  { refId: 1, name: 'Manufacturing' },
  { refId: 2, name: 'Mining' },
  { refId: 3, name: 'Transport' },
  { refId: 4, name: 'Staff' },
  { refId: 5, name: 'Agriculture' },
  { refId: 6, name: 'Individual and HouseHold' },
  { refId: 7, name: 'Hire' },
  { refId: 8, name: 'Distribution' },
  { refId: 9, name: 'Construction' },
  { refId: 10, name: 'Transport' },
  { refId: 11, name: 'Communication' },
  { refId: 12, name: 'Financial Services' },
  { refId: 13, name: 'Factring' },
  { refId: 14, name: 'Tourism' },
  { refId: 15, name: 'Local Authorities' },
  { refId: 16, name: 'Parastatals' },
  { refId: 17, name: 'Other' },
  { refId: 18, name: 'Unspecified' },
  { refId: 19, name: 'Insurance' },
  { refId: 20, name: 'Service' },
  { refId: 21, name: 'Health Services' }
];

export const departments = [
  { refId: 1, name: 'MATERNITYID' },
  { refId: 2, name: 'HOSPITALIZATIONID' },
  { refId: 3, name: 'REHABILITATION HOSPITALIZATIONID' },
  { refId: 4, name: 'PRESCRIPTION DRUGSID' },
  { refId: 5, name: 'CHEMOTHERAPYID' },
  { refId: 6, name: 'HAEMODIALYSISID' },
  { refId: 7, name: 'DENTISTRYID' },
  { refId: 8, name: 'ORTHODONTICID' },
  { refId: 9, name: 'REFRACTION TESTSID' },
  { refId: 10, name: 'SPECTACLESID' },
  { refId: 11, name: 'FAMILY PLANNINGID' },
  { refId: 12, name: 'HEARING AIDID' },
  { refId: 13, name: 'APPLIANCES REPAIRSID' },
  { refId: 14, name: 'GLUCOMETERID' },
  { refId: 15, name: 'OSTOMY APPLIANCESID' },
  { refId: 16, name: 'HOME BASED CAREID' },
  { refId: 17, name: 'PRIVATE AMBULANCESID' },
  { refId: 18, name: 'LEGA CLIPID' },
  { refId: 19, name: 'SURGICAL PROSTHESISID' },
  { refId: 20, name: 'GP/CONSULTATIONID' },
  { refId: 21, name: 'BLOOD TRANSFUSIONID' },
  { refId: 22, name: 'SPECIALISTID' },
  { refId: 23, name: 'PATHOLOGYID' },
  { refId: 24, name: 'RADIOLOGYID' },
  { refId: 25, name: 'PSYCHIATRIC SERVICESID' },
  { refId: 26, name: 'TONOMETRYID' },
  { refId: 27, name: 'CHIROPODY/CHIROPRACTICID' },
  { refId: 28, name: 'NEBULIZING KITID' },
  { refId: 29, name: 'AIR EVACUATIONID' },
  { refId: 30, name: 'GOVT/MUNICIPAL AMBULANCESID' },
  { refId: 31, name: 'FOREIGN SPECIALIST TREATMENTID' }
];

export const services = [
  { refId: 1, name: 'Funeral Service' },
  { refId: 2, name: 'Transport Only' },
  { refId: 3, name: 'Church Hire' },
  { refId: 3, name: 'Cash in Lieu' }
];

export const salaryDays = [
  { refId: 1, name: '1st' },
  { refId: 2, name: '2nd' },
  { refId: 3, name: '3rd' },
  { refId: 4, name: '4th' },
  { refId: 5, name: '5th' },
  { refId: 6, name: '6th' },
  { refId: 7, name: '7th' },
  { refId: 8, name: '8th' },
  { refId: 9, name: '9th' },
  { refId: 10, name: '10th' },
  { refId: 11, name: '11th' },
  { refId: 12, name: '22th' },
  { refId: 13, name: '13th' },
  { refId: 14, name: '14th' },
  { refId: 15, name: '15th' },
  { refId: 16, name: '16th' },
  { refId: 17, name: '17th' },
  { refId: 18, name: '18th' },
  { refId: 19, name: '19th' },
  { refId: 20, name: '20th' },
  { refId: 21, name: '11st' },
  { refId: 22, name: '22nd' },
  { refId: 23, name: '23rd' },
  { refId: 24, name: '24th' },
  { refId: 25, name: '25th' },
  { refId: 26, name: '26th' },
  { refId: 27, name: '27th' },
  { refId: 28, name: '28th' },
  { refId: 29, name: '29th' },
  { refId: 30, name: '30th' },
  { refId: 31, name: '31st' }
];

export const limitTypes = [
  { refId: 1, name: 'Group Limit' },
  { refId: 2, name: 'Family Limit' },
  { refId: 3, name: 'Individual Limit' },
  { refId: 4, name: 'Summed' }
];

export const users = [
  { refId: 1, name: 'System' },
  { refId: 4, name: 'System Admin' },
  { refId: 5, name: 'provident@zimta.co.zw' },
  { refId: 6, name: 'members@zimta.co.zw' },
  { refId: 7, name: 'simba@zimta.co.zw' },
  { refId: 8, name: 'mbmageza@zimta.co.zw' },
  { refId: 9, name: 'mmusaombere@zimta.co.zw' },
  { refId: 10, name: 'ndlovus@zimta.co.zw' },
  { refId: 12, name: 'kossam@zimta.co.zw' },
  { refId: 13, name: 'mangena@zimta.co.zw' },
  { refId: 31, name: 'byo@zimta.co.zw' },
  { refId: 32, name: 'masvingo@zimta.co.zw' },
  { refId: 33, name: 'matnorth@zimta.co.zw' },
  { refId: 34, name: 'matsouth@zimta.co.zw' },
  { refId: 35, name: 'harare@zimta.co.zw' },
  { refId: 36, name: 'midlands@zimta.co.zw' },
  { refId: 37, name: 'mashwest@zimta.co.zw' },
  { refId: 38, name: 'mashcentral@zimta.co.zw' },
  { refId: 39, name: 'masheast@zimta.co.zw' },
  { refId: 40, name: 'manica@zimta.co.zw' }
];

export const paymentJournals = [
  { refId: 807100, name: 'Cash' },
  { refId: 807200, name: 'Cheque' },
  { refId: 807300, name: 'Bank Transfer' }
  // { refId: 807400, name: 'Council Slip' },
];

export const ssbFileCode = [
  { refId: '43580', name: '43580' },
  { refId: '43690', name: '43690' },
  { refId: '00000', name: '00000' }
  // { refId: 807400, name: 'Council Slip' },
];

export const suffixes = [
  { refId: '01', name: '01 Member' },
  { refId: '02', name: '02 Spouse' },
  { refId: '03', name: '03 Child 1' },
  { refId: '04', name: '04 Child 2' },
  { refId: '05', name: '05 Child 3' },
  { refId: '06', name: '06 Child 4' },
  { refId: '07', name: '07 Legacy 1' },
  { refId: '08', name: '08 Legacy 2' },
  { refId: '09', name: '09 Legacy 3' },
  { refId: '10', name: '10 Legacy 1' },
  { refId: '11', name: '11 Legacy 2' },
  { refId: '99', name: '99 Nominated not Beneficiary' }
  // { refId: 807400, name: 'Council Slip' },
];

export const benefitTypes = [
  { refId: 'ZPF', name: 'ZPF' },
  { refId: 'Legacy', name: 'Legacy' }
  // { refId: 807400, name: 'Council Slip' },
];
